/**
 * API module exports
 */
import ApiClient from './client';
import { ItemsApi } from './itemsApi';
import { AuthorsApi } from './authorsApi';
import { ListsApi } from './listsApi';
import { TagsApi } from './tagsApi';
import { SitesApi } from './sitesApi';
import { PendingApi } from './pendingApi';
import { UsersApi } from './usersApi';
import { UrlsApi } from './urlsApi';

/**
 * Creates API service instances
 * @param {function} getToken - Function that returns current auth token
 * @returns {object} Object containing all API service instances
 */
export function createApiServices(getToken) {
  const apiClient = new ApiClient(process.env.REACT_APP_API_URL, getToken);

  return {
    itemsApi: new ItemsApi(apiClient),
    authorsApi: new AuthorsApi(apiClient),
    listsApi: new ListsApi(apiClient),
    tagsApi: new TagsApi(apiClient),
    sitesApi: new SitesApi(apiClient),
    pendingApi: new PendingApi(apiClient),
    usersApi: new UsersApi(apiClient),
    urlsApi: new UrlsApi(apiClient),
  };
}

export { ApiClient };
export { ItemsApi } from './itemsApi';
export { AuthorsApi } from './authorsApi';
export { ListsApi } from './listsApi';
export { TagsApi } from './tagsApi';
export { SitesApi } from './sitesApi';
export { PendingApi } from './pendingApi';
export { UsersApi } from './usersApi';
export { UrlsApi } from './urlsApi';
